module.exports = {
    /**
     * The pagePath might be provided in the following format:
     * 8264,aw-cmt,cmt-music-awards,voting
     * 
     * Use the third and fourth values in the comma separated list to create the pagePath.
     * e.g. cmt-music-awards/voting
     */

    pagePath: 'movie-and-tv-awards/voting',
    ptype: 'vote',
    franchise: 'movie-and-tv-awards',
    event: 'movie-and-tv-awards-2023'
};


// WEBPACK FOOTER //
// ./app/scripts/constants/_ad.js